/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FollowersInputs */

const en_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Followers`)
};

const es_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguidores`)
};

const fr_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnés`)
};

const de_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follower`)
};

const id_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengikut`)
};

/** @type {(inputs: FollowersInputs) => LocalizedString} */
const ja_followers = en_followers;

/** @type {(inputs: FollowersInputs) => LocalizedString} */
const zh_followers = en_followers;

/** @type {(inputs: FollowersInputs) => LocalizedString} */
const ar_followers = en_followers;

/** @type {(inputs: FollowersInputs) => LocalizedString} */
const it_followers = en_followers;

/** @type {(inputs: FollowersInputs) => LocalizedString} */
const ru_followers = en_followers;

/** @type {(inputs: FollowersInputs) => LocalizedString} */
const pt_followers = en_followers;

/** @type {(inputs: FollowersInputs) => LocalizedString} */
const ko_followers = en_followers;

/**
* | output |
* | --- |
* | "Followers" |
*
* @param {FollowersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const followers = /** @type {((inputs?: FollowersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FollowersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_followers(inputs)
	if (locale === "es") return es_followers(inputs)
	if (locale === "fr") return fr_followers(inputs)
	if (locale === "de") return de_followers(inputs)
	if (locale === "ja") return ja_followers(inputs)
	if (locale === "zh") return zh_followers(inputs)
	if (locale === "ar") return ar_followers(inputs)
	if (locale === "id") return id_followers(inputs)
	if (locale === "it") return it_followers(inputs)
	if (locale === "ru") return ru_followers(inputs)
	if (locale === "pt") return pt_followers(inputs)
	return ko_followers(inputs)
});